import Mapper from '@/models/mappers/Mapper';
import { Product } from '@/models/entities/Product';
import { ProductDTO } from '@/api/dto/ProductDTO';
import { mapValueToInterface } from '@/utils/models';
import { ProductCategoryOptionMapper } from '@/models/mappers/ProductCategoryOptionMapper';

const optionMapper = new ProductCategoryOptionMapper();

export class ProductMapper extends Mapper<Product, ProductDTO> {
  mapFromDTO(productDTO: ProductDTO): Product {
    const product = new Product(<Partial<Product>>productDTO);
    product.productCategoryOptions = (productDTO.productCategoryOptions || []).map(
      opt => optionMapper.mapFromDTO(opt),
    );
    return product;
  }

  mapToDTO(product: Product): ProductDTO {
    return mapValueToInterface(product) as ProductDTO;
  }
}
